import React from 'react';
import { PILLAR, NUT_GROUP } from './atlasData';

const KEYS = Object.keys(NUT_GROUP);
const SHORT = { kcal: 'KCAL', pro: 'PRO', carb: 'CARB', fat: 'FAT', fib: 'FIB', sug: 'SUG', o3: 'Ω3', cho: 'CHO',
  vB1: 'B1', vB2: 'B2', vB3: 'B3', vB5: 'B5', vB6: 'B6', vB9: 'B9', vB12: 'B12', vC: 'C', vA: 'A', vD: 'D', vE: 'E', vK: 'K' };

const arc = (r, a0, a1) => {
  const p = (a) => [50 + r * Math.cos(a), 50 + r * Math.sin(a)];
  const [x0, y0] = p(a0); const [x1, y1] = p(a1);
  return `M ${x0} ${y0} A ${r} ${r} 0 0 1 ${x1} ${y1}`;
};

/* Slowly rotating nutrient ring; centre stays still. Fills its parent (square, contained). */
export const NutrientWheel = ({ count, onOpen }) => {
  const step = (Math.PI * 2) / KEYS.length;
  return (
    <div className="w-full h-full flex items-center justify-center" style={{ containerType: 'size' }}>
      <style>{`@keyframes nwSpin{to{transform:rotate(360deg)}} @keyframes nwSpinR{to{transform:rotate(-360deg)}}
        @keyframes nwPulse{0%,100%{opacity:.55}50%{opacity:1}}`}</style>
    <button type="button" onClick={onOpen} data-testid="aegis-nutrient-wheel"
      className="relative flex-shrink-0 active:scale-[0.98] transition-transform"
      style={{ width: 'min(100cqw, 100cqh)', height: 'min(100cqw, 100cqh)' }}>
      <svg viewBox="0 0 100 100" className="absolute inset-0 w-full h-full" style={{ animation: 'nwSpin 60s linear infinite', willChange: 'transform', filter: 'drop-shadow(0 0 6px rgba(185,120,255,0.35))' }}>
        {KEYS.map((k, i) => {
          const a0 = i * step - Math.PI / 2 + 0.012; const a1 = a0 + step - 0.024;
          const c = PILLAR[NUT_GROUP[k]];
          const mid = (a0 + a1) / 2;
          return (
            <g key={k}>
              <path d={arc(44, a0, a1)} stroke={c} strokeWidth="5.4" fill="none"/>
              <text x={50 + 44 * Math.cos(mid)} y={50 + 44 * Math.sin(mid)} fill="#05050A" fontSize="2.3" fontWeight="700"
                textAnchor="middle" dominantBaseline="central" fontFamily="Outfit"
                transform={`rotate(${(mid * 180) / Math.PI + 90} ${50 + 44 * Math.cos(mid)} ${50 + 44 * Math.sin(mid)})`}>
                {SHORT[k] || k.toUpperCase()}
              </text>
            </g>
          );
        })}
      </svg>
      <svg viewBox="0 0 100 100" className="absolute inset-0 w-full h-full" style={{ animation: 'nwSpinR 90s linear infinite', willChange: 'transform' }}>
        {Object.values(PILLAR).map((c, i) => (
          <path key={c} d={arc(35, (i * Math.PI) / 3 - Math.PI / 2 + 0.08, ((i + 1) * Math.PI) / 3 - Math.PI / 2 - 0.08)}
            stroke={c} strokeWidth="0.8" fill="none" strokeDasharray="1.2 1.6" opacity="0.8"/>
        ))}
      </svg>
      <div className="absolute rounded-full flex flex-col items-center justify-center text-center"
        style={{ inset: '22%', background: 'radial-gradient(circle at 40% 35%, #15121f, #050508 70%)',
          boxShadow: '0 0 30px rgba(185,120,255,0.25), inset 0 0 18px rgba(255,178,101,0.15)', border: '1px solid rgba(255,178,101,0.35)' }}>
        <span className="font-['Outfit'] uppercase" style={{ fontSize: 8, letterSpacing: '0.3em', color: PILLAR.aegis }}>Nutrient</span>
        <span className="font-['Cinzel'] uppercase leading-none mt-0.5" style={{ fontSize: 15, letterSpacing: '0.14em',
          background: `linear-gradient(90deg, ${PILLAR.fuel}, ${PILLAR.force}, ${PILLAR.energy}, ${PILLAR.power})`,
          WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent' }}>Chart</span>
        <span className="font-['Cormorant_Garamond'] italic mt-1" style={{ fontSize: 11, color: 'rgba(255,255,255,0.6)' }} data-testid="aegis-nutrient-count">
          {count ? `${count.toLocaleString()} foods` : 'Macro · Micro'}
        </span>
        <span className="font-['Outfit'] uppercase mt-1" style={{ fontSize: 7, letterSpacing: '0.24em', color: PILLAR.force, animation: 'nwPulse 3s ease-in-out infinite' }}>
          Tap to explore
        </span>
      </div>
    </button>
    </div>
  );
};

export default NutrientWheel;
